<script setup lang="ts">
import appIcon from '@/assets/images/download/app_icon.png'

defineProps<{ visible: boolean; senderName: string }>()
const emit = defineEmits<{ (e: 'click'): void; (e: 'close'): void }>()

// 上滑手势:上滑 >20px 直接关闭(不等 3s);上滑不触发点击跳转
let startY = 0
let swiped = false
function onTouchStart(e: TouchEvent) {
  startY = e.touches[0].clientY
  swiped = false
}
function onTouchMove(e: TouchEvent) {
  if (startY - e.touches[0].clientY > 20) swiped = true
}
function onTouchEnd() {
  if (swiped) emit('close')
}
function onClick() {
  if (swiped) return
  emit('click')
}
</script>

<template>
  <Transition name="im-toast">
    <div v-if="visible" class="im-toast"
      @click="onClick" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd">
      <img :src="appIcon" class="im-toast-icon" alt="app">
      <div class="im-toast-content">
        <span class="im-toast-title">消息</span>
        <span class="im-toast-text">{{ senderName }} 发来一条新消息</span>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.im-toast {
  position: fixed;
  top: var(--inset-top);
  left: 50%;
  margin-left: -45%;
  width: 90%;
  margin-top: 6px;
  padding: 12px;
  border-radius: 20px;
  /* 毛玻璃:半透渐变 + backdrop-filter 模糊背后内容 */
  background: linear-gradient(135deg, rgba(57, 140, 255, 0.6), rgba(57, 140, 255, 0.4));
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 8px 24px rgba(57, 140, 255, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.3);
  z-index: 9999;
  touch-action: none;
  will-change: transform, opacity;
}
.im-toast-icon {
  width: 42px;
  height: 42px;
  margin-right: 12px;
  border-radius: 10px;
}
.im-toast-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2px 0;
}
.im-toast-title {
  font-weight: 600;
  color: #fff;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.im-toast-text {
  color: #fff;
  margin-top: 6px;
  font-size: 13px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.im-toast-enter-active,
.im-toast-leave-active {
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.35s ease;
}
.im-toast-enter-from,
.im-toast-leave-to {
  transform: translateY(-130%);
  opacity: 0;
}
</style>
